__turbopack_context__.v({
  "item": "breadthofentitylists-module-scss-module__kf3JhG__item",
});
